__turbopack_context__.v({
  "codeContainer": "code-input-module__al3sDW__codeContainer",
  "codeInput": "code-input-module__al3sDW__codeInput",
  "error": "code-input-module__al3sDW__error",
});
